import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {userRegister} from "../../services/userRegister";
import TextareaAutosize from 'react-autosize-textarea';
import {langRegister} from "../../services/langRegister";
import innerHtml from 'react-inner-html';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {scraperRegister} from "../../services/scraperRegister";
import BoosterHeader from "../../components/booster-header/component";
import {flowRegister} from "../../services/flowRegister";
import {themeRegister} from "../../services/themeRegister";
import {yieldlockRegister} from "../../services/yieldlockRegister";
import {tokenRegister} from "../../services/tokenRegister";

class BoosterSlogans extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industry: null,
            quotes: [],
            selected: {},
            isLoadingButton: false,
            isLoading: true,
            page: 1,
            page_load: 10,
            admin: false,
            customQuote: {
                selected: false,
                saved: false,
                text: "",
                modal: false,
                custom: true
            },
            customCount: 0,
            error: false,
            scraped: false,
            sale: "both"
        };
        this._renderAdminQuote = this._renderAdminQuote.bind(this);
    };

    componentDidMount() {
        let token = tokenRegister.getToken();
        if (!token) {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateUser();
        this._updateScraperData();

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/booster/slogans-custom');
            ReactGA4.send({ hitType: "pageview", page: "/booster/slogans-custom" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }

        //CHECK VIEW
        let view = quotesRegister.getView();
        if (!view) {
            cartRegister.setQuotes(null);
        }
        quotesRegister.setView("custom");

        cartRegister.setSelectedIndustries(null);

    }

    _updateUser() {
        try {
            let user = userRegister.get();
            if (user) {
                this.setState({reseller: user.reseller, inhouse: user.inhouse});
            }
        } catch (error) {
            this.setState({
                error: true
            });
        }
    }

    _updateData() {
        try {
            let stored_data = cartRegister.get();

            //SET SALE TYPE
            //this.setState({sale: stored_data.crossroad});

            /*
            if (stored_data.admin_image) {
                if (!stored_data.admin_image.data_url && !stored_data.admin_image.web_url) {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
                }
            }
            */

            if (stored_data.industry) {
                this.setState({
                    industry: stored_data.industry
                }, () => {
                    this._updateQuotes(this.state.industry.id, salesChannelRegister.get('market'), langRegister.lang());
                });
            } else {
                //this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
                if (salesChannelRegister.get("name") === "yieldlock") {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/ads");
                } else {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/theme");
                }
            }

        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateScraperData() {

        this.setState({sale: flowRegister.getValue("slogan_type")}, () => {
            this._updateData();
        });

    }

    _updateQuotes(industry, market, lang) {
        try {
            let stored_quotes = null;//quotesRegister.get();
            let stored_page = null;//quotesRegister.page();
            if (stored_quotes) {
                this.setState({
                    quotes: stored_quotes,
                    page: stored_page,
                    isLoading: false
                }, () => {
                    this._updateQuote();
                });
            } else {
                dataRegister.quotes(industry, market, lang).then((data) => {

                    if (data.errors) {
                        this.setState({
                            isLoading: false
                        });
                    } else {

                        let all = data;
                        let slogans = [];

                        //ADD EXTRAS
                        if (flowRegister.getValue("slogan_extras")) {
                            let extras = flowRegister.getValue("slogan_extras");
                            let highlight = flowRegister.getValue("slogan_highlight");
                            for (let i = 0; i < extras.length; i++) {

                                if (extras[i].title.indexOf(highlight) === -1 && (extras[i].highlight === undefined || extras[i].highlight === null)) {
                                    extras[i].highlight = true;
                                }

                                slogans.unshift({
                                    slogan: extras[i].title,
                                    detail: extras[i].detail,
                                    id: extras[i].title + extras[i].detail, //window.crypto.getRandomValues(new Uint32Array(1))[0].toString(16),
                                    custom: true,
                                    highlight: extras[i].highlight,
                                    sale: "both",
                                    type: (salesChannelRegister.get("name")==="yieldlock"?"yieldlock":(salesChannelRegister.get("name")==="boostabostad"?"boostabostad":"property")),
                                    index: 0
                                });
                                //console.log(extras[i].title);
                                this.state.customCount++;
                            }
                        }

                        //EXCLUDE
                        if (flowRegister.getValue("slogan_excludes")) {
                            let excluded = flowRegister.getValue("slogan_excludes");
                            let all_slogans = [];
                            for (let i = 0; i < all.length; i++) {
                                let exist = false;
                                for (let m = 0; m < excluded.length; m++) {
                                    if (excluded[m].toLowerCase() === all[i].slogan.toLowerCase()) {
                                        exist = true;
                                        break;
                                    }
                                }
                                if (!exist) {
                                    all_slogans.push(all[i]);
                                }
                            }
                            all_slogans = all_slogans.sort(function (a, b) {
                                if (a.slogan < b.slogan) {
                                    return -1;
                                }
                                if (a.slogan > b.slogan) {
                                    return 1;
                                }
                                return 0;
                            });
                            slogans = slogans.concat(all_slogans);
                        } else {
                            all = all.sort(function (a, b) {
                                if (a.slogan < b.slogan) {
                                    return -1;
                                }
                                if (a.slogan > b.slogan) {
                                    return 1;
                                }
                                return 0;
                            });
                            slogans = slogans.concat(all);
                        }

                        //MATCH AMENATIES
                        if (flowRegister.getValue("slogan_matches")) {
                            let top = [];
                            let bottom = [];
                            let matches = flowRegister.getValue("slogan_matches");
                            for (let i = 0; i < slogans.length; i++) {
                                let exist = false;
                                for (let m = 0; m < matches.length; m++) {
                                    if (matches[m].toLowerCase() === slogans[i].slogan.toLowerCase()) {
                                        slogans[i].highlight = true;
                                        top.push(slogans[i]);
                                        exist = true;
                                        break;
                                    }
                                }
                                if (!exist) {
                                    bottom.push(slogans[i]);
                                }
                            }
                            slogans = top.concat(bottom);
                        }

                        //MATCH TAGS
                        /*
                        if(flowRegister.getValue("slogan_tags")){
                            let top = [];
                            let bottom = [];
                            let tags = flowRegister.getValue("slogan_tags");
                            for(let i = 0; i < slogans.length; i++){
                                let exist = false;
                                for(let m = 0; m < tags.length; m++){
                                    if(tags[m].toLowerCase() === slogans[i].slogan.toLowerCase()){
                                        slogans[i].highlight = true;
                                        top.push(slogans[i]);
                                        exist = true;
                                        break;
                                    }
                                }
                                if(!exist){
                                    bottom.push(slogans[i]);
                                }
                            }
                            slogans = top.concat(bottom);
                        }
                        /*/

                        let custom = quotesRegister.getCustom();
                        if(custom){
                            slogans = custom.concat(slogans);
                        }

                        this.setState({
                            quotes: slogans,
                            customCount: this.state.customCount, //this.state.customCount + custom.length,
                            isLoading: false
                        }, () => {
                            //quotesRegister.set(this.state.quotes, 1, lang);
                            this._updateQuote();
                        });
                    }

                }, (error) => {
                    this.setState({error: true});
                });
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateQuote() {
        let stored_quotes = cartRegister.get();
        if (stored_quotes.quotes) {
            this.setState({
                selected: stored_quotes.quotes
            }, () => {
                let quotes = [];
                let selected = [];
                for (let i = 0; i < this.state.quotes.length; i++) {
                    if (this.state.selected[this.state.quotes[i].id]) {
                        if (!this.state.quotes[i].index) {
                            this.state.quotes[i].index = this.state.selected[this.state.quotes[i].id].index;
                        }
                        selected.push(this.state.quotes[i]);
                    } else {
                        quotes.push(this.state.quotes[i]);
                    }
                }
                selected.sort(function (a, b) {
                    return a.index - b.index;
                });
                selected = selected.concat(quotes);
                this.setState({
                    quotes: selected
                }, () => {
                });
            });
        } else {

        }
    }

    _selectQuote(prop) {
        try {
            if (!this.state.isLoading) {
                if (this.state.customQuote.selected) {
                    this.state.customQuote.selected = false;
                    this.setState({
                        customQuote: this.state.customQuote
                    });
                }
                if (this.state.selected[prop.id]) {
                    delete this.state.selected[prop.id];
                    prop.selected = false;
                    this.setState({
                        selected: this.state.selected,
                        quotes: this.state.quotes
                    }, () => {
                        if (prop.detail === "activation") {
                            let theme_data = themeRegister.getValue();
                            theme_data.slogan_activation = prop.slogan;
                            themeRegister.setValue(theme_data);
                        }
                        if (prop.detail === "validation") {
                            let theme_data = themeRegister.getValue();
                            theme_data.slogan_validation = prop.slogan;
                            themeRegister.setValue(theme_data);
                        }
                        if (prop.detail === "offer") {
                            let theme_data = themeRegister.getValue();
                            if (salesChannelRegister.get('name') === "yieldlock") {
                                let up_front = yieldlockRegister.getValue("up_front");
                                let yield_value = yieldlockRegister.getValue("yield");
                                let years_value = yieldlockRegister.getValue("years");
                                if (up_front && years_value && yield_value) {

                                    years_value = JSON.parse(years_value);
                                    let string = (yield_value * years_value.years)  + "% ROI Up-Front";
                                    theme_data.slogan_offer = string;

                                } else if (years_value && yield_value) {

                                    years_value = JSON.parse(years_value);
                                    let string = yield_value + "% Yield Assured (" + years_value.years + "Y)";
                                    theme_data.slogan_offer = string;

                                } else {
                                    theme_data.slogan_offer = prop.slogan;
                                }
                            } else {
                                theme_data.slogan_offer = prop.slogan;
                            }
                            themeRegister.setValue(theme_data);
                        }
                        if (prop.detail === "action") {
                            let theme_data = themeRegister.getValue();
                            theme_data.slogan_action = prop.slogan;
                            themeRegister.setValue(theme_data);
                            themeRegister.setItem("last_subtitle", prop.slogan);
                        }
                        cartRegister.setQuotes(this.state.selected);
                    });

                } else {


                    if (Object.keys(this.state.selected).length > 3) {
                        this.setState({
                            isLoading: true
                        });

                        cartRegister.setQuotes(this.state.selected);
                        quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                        setTimeout(() => {
                            if (salesChannelRegister.get("name") === "yieldlock") {
                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/ads");
                            } else {
                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/theme");
                            }
                        }, 1000);

                    } else {

                        prop.selected = true;
                        this.state.selected[prop.id] = prop;
                        let index = 0;
                        for (let key in this.state.selected) {
                            if (this.state.selected[key].index && this.state.selected[key].index > index) {
                                index = this.state.selected[key].index;
                            }
                        }
                        index++;
                        this.state.selected[prop.id].index = index;


                        if (salesChannelRegister.get("name") !== "yieldlock") {
                            if (Object.keys(this.state.selected).length === 1) {
                                let theme_data = themeRegister.getValue();
                                theme_data.slogan_activation = prop.slogan;
                                themeRegister.setValue(theme_data);
                            }
                            if (Object.keys(this.state.selected).length === 2) {
                                let theme_data = themeRegister.getValue();
                                theme_data.slogan_validation = prop.slogan;
                                themeRegister.setValue(theme_data);
                            }
                            if (Object.keys(this.state.selected).length === 3) {
                                let theme_data = themeRegister.getValue();
                                theme_data.slogan_offer = prop.slogan;
                                themeRegister.setValue(theme_data);
                            }
                            if (Object.keys(this.state.selected).length === 4) {
                                let theme_data = themeRegister.getValue();
                                theme_data.slogan_action = prop.slogan;
                                themeRegister.setValue(theme_data);
                                themeRegister.setItem("last_subtitle", prop.slogan);
                            }
                        }


                        this.setState({
                            selected: this.state.selected,
                            quotes: this.state.quotes
                        }, () => {
                            cartRegister.setQuotes(this.state.selected);
                            if (Object.keys(this.state.selected).length > 3) {
                                this.setState({
                                    isLoading: true
                                });
                                quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                                setTimeout(() => {
                                    if (salesChannelRegister.get("name") === "yieldlock") {
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/ads");
                                    } else {
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/theme");
                                    }
                                }, 1000);
                            }
                        });

                    }
                }
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _setCustomQuote(item) {
        try {
            let words = this.state.customQuote.text.split(" ");
            for (let i = 0; i < words.length; i++) {
                words[i] = capitalizeFLetter(words[i]);
            }
            this.state.customQuote.text = words.join(" ");
        } catch (e) {
            console.log(e);
        }
        let slogan = {
            slogan: this.state.customQuote.text,
            id: window.crypto.getRandomValues(new Uint32Array(1))[0].toString(16),
            custom: true,
            sale: "both",
            type: (salesChannelRegister.get("name")==="yieldlock"?"yieldlock":(salesChannelRegister.get("name")==="boostabostad"?"boostabostad":"property")),
            index: 0
        };
        this.state.quotes.unshift(slogan);
        this.setState({quotes: this.state.quotes, customCount: this.state.customCount + 1}, () => {
            quotesRegister.setCustomQuote(slogan);
        });

        function capitalizeFLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

    _addCustomQuote() {
        try {
            this.state.customQuote.modal = true;
            this.state.customQuote.text = "";
            this.setState({
                customQuote: this.state.customQuote
            });
        } catch (error) {
            this.setState({error: true});
        }
    }

    _moreQuotes() {
        try {
            this.setState({page_load: window.innerWidth > 1050 ? 10 : 10}, () => {
                this.setState({
                    page: this.state.page + (this.state.page === 1 ? 2 : 1)
                }, () => {
                    this._scrollTo("bottom");
                    quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                });
            });
        } catch (error) {
            this.setState({error: true});
        }
    }

    _next() {
        if (Object.keys(this.state.selected).length > 3 || this.state.customQuote.saved) {
            if (this.state.customQuote.saved && this.state.customQuote.selected) {
                cartRegister.setAdAdminQuotes(this.state.customQuote);
            }
            if (salesChannelRegister.get("name") === "yieldlock") {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/ads");
            } else {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/theme");
            }
        }
    }

    _back() {
        if (this.state.inhouse) {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slideshow");
        } else {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
        }
    }

    _scrollTo(element) {
        let offSet = 0, timeout = null;
        element = document.getElementById(element);
        if (element) {
            const elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
            window.scroll({top: elemPos + offSet, left: 0, behavior: 'smooth'});
        }
    }

    _renderAdminQuote(e) {
        try {
            const re = /^[\x00-\xFF]*$/;
            if (e.target.value === '' || re.test(e.target.value)) {
                this.state.customQuote.text = e.target.value;
                this.setState({customQuote: this.state.customQuote});
            }
        } catch (e) {
            console.log(e);
        }
    }

    _renderQuote(slogan) {
        try {
            let highlight = flowRegister.getValue("slogan_highlight");
            let string = slogan.replace(highlight, '<bold><div>&nbsp;' + highlight + '&nbsp;</div></bold>');
            return (<span {...innerHtml(string)}></span>);
        } catch (error) {
            return slogan;
        }
    }

    _renderText(item) {
        return langRegister.get("signup-quotes", item);
    }

    render() {
        return (
            <div>
                <BoosterHeader view={"signup"} props={this.props}/>
                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.container}>
                        {
                            !this.state.error &&
                            <div style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                 className={Styles.title}>
                                {
                                    this.state.customQuote.modal &&
                                    <div
                                        style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}>
                                        {this._renderText("item_5")}
                                    </div>
                                    ||
                                    <div
                                        style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}>
                                        {this._renderText("item_1")}..
                                    </div>
                                }
                            </div>
                        }
                        {
                            !this.state.error &&
                            <div className={Styles.quotesContainer}>
                                {
                                    !this.state.customQuote.modal && this.state.inhouse &&
                                    <div
                                        onClick={() => this._addCustomQuote()}
                                        className={Styles.quotesContainerItem}>
                                        <div className={Styles.quotesContainerItemQuote}>
                                            <div className={Styles.quotesContainerItemQuoteIcon}>
                                                +
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    !this.state.customQuote.modal &&
                                    this.state.quotes.filter((item) => {
                                        return (item.sale === this.state.sale || item.sale === "both")
                                    }).filter((item) => {
                                        return (item.type === (salesChannelRegister.get("name")==="yieldlock"?"yieldlock":(salesChannelRegister.get("name")==="boostabostad"?"boostabostad":"property")))
                                    }).filter((item, i) => {
                                        if (this.state.admin && this.state.page === 1) {
                                            if (window.innerWidth > 1050) {
                                                return i < 15 + this.state.customCount
                                            } else {
                                                return i < 10 + this.state.customCount
                                            }
                                        } else if (this.state.admin) {
                                            return i < (this.state.page * this.state.page_load) + this.state.customCount
                                        } else {
                                            return i < (this.state.page * this.state.page_load) + this.state.customCount
                                        }
                                    }).map((prop, i) => {
                                        return (
                                            <div key={i}
                                                 onClick={() => this._selectQuote(prop)}
                                                 className={
                                                     cx(Styles.quotesContainerItem,
                                                         {
                                                             [Styles.quotesContainerItemActive]: this.state.selected[prop.id],
                                                         })
                                                 }>
                                                {
                                                    !prop.highlight &&
                                                    <div className={Styles.quotesContainerItemQuote}>
                                                        {this._renderQuote(prop.slogan)}
                                                    </div>
                                                }
                                                {
                                                    prop.highlight &&
                                                    <div className={Styles.quotesContainerItemQuote}>
                                                        <bold>{prop.slogan}</bold>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    })
                                }
                                {
                                    this.state.customQuote.modal &&
                                    <div className={Styles.customQuote}>
                                        {
                                            false &&
                                            <input
                                                value={this.state.customQuote.text}
                                                onChange={this._renderAdminQuote}
                                                placeholder={this._renderText("item_6")}
                                                maxLength={30}
                                                className={Styles.customQuoteTextArea}
                                            />
                                        }
                                        <input
                                            maxLength={30}
                                            value={this.state.customQuote.text}
                                            onChange={(event) => {
                                                String.prototype.allReplace = function (obj) {
                                                    var retStr = this;
                                                    for (var x in obj) {
                                                        try {
                                                            retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
                                                        } catch (e) {
                                                        }
                                                    }
                                                    return retStr;
                                                };
                                                let string = event.target.value.allReplace({
                                                    '!': '',
                                                    '&': '',
                                                    ';': '',
                                                    '_': '',
                                                    '`': '',
                                                    '+': '',
                                                    '≈': '',
                                                    '[': '',
                                                    ']': '',
                                                    '|': '',
                                                    '§': '',
                                                    '∞': '',
                                                    '$': '',
                                                    '£': '',
                                                    '©': '',
                                                    '#': '',
                                                    '€': '',
                                                    '%': '',
                                                    '=': '',
                                                    ')': '',
                                                    '(': '',
                                                    '/': '',
                                                    '{': '',
                                                    '}': ''
                                                });
                                                this.state.customQuote.text = string;
                                                this.setState({customQuote: this.state.customQuote});
                                            }}
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                            className={Styles.customQuoteTextArea}
                                            placeholder={this._renderText("item_6")}
                                        />
                                        {
                                            this.state.customQuote.modal &&
                                            <div className={Styles.customQuoteButtons}>
                                                <div className={Styles.customQuoteButtonsItem}>
                                                    <div onClick={() => {
                                                        this.state.customQuote.text = "";
                                                        this.state.customQuote.saved = false;
                                                        this.state.customQuote.modal = false;
                                                        this.state.customQuote.selected = false;
                                                        this.setState({customQuote: this.state.customQuote})
                                                    }}
                                                         style={salesChannelRegister.get('name') === 'yieldlock' ? {background: '#E65032'} : {}}
                                                         className={Styles.customQuoteButtonsItemRemove}>
                                                        <img className={Styles.customQuoteButtonsItemRemoveIcon}
                                                             src={require("../../assets/images/AB_cross_bold.png")}/>
                                                    </div>
                                                </div>
                                                <div className={Styles.customQuoteButtonsItem}>
                                                    <div
                                                        onClick={() => {
                                                            if (this.state.customQuote.text !== "") {
                                                                this.state.customQuote.saved = true;
                                                                this.state.customQuote.modal = false;
                                                                this.setState({
                                                                    customQuote: this.state.customQuote
                                                                }, () => {
                                                                    this._setCustomQuote()
                                                                })
                                                            }
                                                        }
                                                        }
                                                        className={
                                                            cx(Styles.customQuoteButtonsItemSave,
                                                                {
                                                                    [Styles.customQuoteButtonsItemSaveActive]: this.state.customQuote.text !== "",
                                                                })
                                                        }>
                                                        <img className={Styles.customQuoteButtonsItemRemoveIcon}
                                                             src={require("../../assets/images/AB_checkmark_bold.png")}/>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        {
                            !this.state.customQuote.modal &&
                            <div onClick={() => this._moreQuotes()} className={
                                cx(Styles.plusIcon,
                                    {
                                        [Styles.plusIconActive]: this.state.quotes.filter((item) => {
                                            return (item.sale === this.state.sale || item.sale === "both")
                                        }).filter((item) => {
                                            return (item.type === (salesChannelRegister.get("name")==="yieldlock"?"yieldlock":(salesChannelRegister.get("name")==="boostabostad"?"boostabostad":"property")))
                                        }).length > (this.state.page * this.state.page_load),
                                    })
                            }>
                                {
                                    this.state.isLoadingButton &&
                                    <BeatLoader size={12} color={'#ffffff'} loading={true}/>
                                    ||
                                    <img className={Styles.plusIconItem}
                                         src={require("../../assets/images/plus_sign_white_small.png")}/>
                                }
                            </div>
                        }
                        {
                            !this.state.customQuote.modal &&
                            <div>
                                {
                                    false &&
                                    <div className={
                                        cx(Styles.button,
                                            {
                                                [Styles.buttonActive]: Object.keys(this.state.selected).length > 3 || this.state.customQuote.saved,
                                            })
                                    } onClick={() => this._next()}>
                                        <div>{this._renderText("item_3")}</div>
                                    </div>
                                }
                                <div
                                    onClick={() => this._back()}
                                    style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                    className={
                                        cx(Styles.backButton,
                                            {
                                                [Styles.backButtonCenter]: true,
                                            })
                                    }>
                                    {this._renderText("item_4")}
                                </div>
                            </div>
                        }
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width: "100%"}}/>
            </div>
        );
    }
}

export default BoosterSlogans;


// WEBPACK FOOTER //
// ./src/pages/booster-slogans/component.js